<template>
  <div>
    <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
    <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

    <v-row>
      <v-col class="d-flex justify-center"> <h1>Administrativo</h1></v-col>
    </v-row>
  </div>
</template>

<script>
import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";

export default {
  components: {
    menulateral,
    barraprincipaladmin,
  },

  data() {
    return {
      menu_visible: false,
    };
  },

  beforeCreate() {
    const token = sessionStorage.getItem('datax')
               
    this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})     
        .then((response)=>{

          const data = response.data
          
          if(data.codigo == 'lgout')
            this.$router.push({"name":'AdminLogin'})
          
        })
        .catch((error)=>{
          console.log("Error "+error);
        })
  },

  methods: {
    mtMenuVisible(value) {
      this.menu_visible = value;
    },
  },
};
</script>